import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon, Tooltip } from '@/shared/ui';

import {
  dentalPhotoToolbarMessages,
  EDIT_TOOLS,
  TOOL_TO_ICON,
  TOOL_TO_ICON_SIZE,
} from '../../config';
import type { DentalPhotoEditTool } from '../../config';

import styles from './DentalPhotoToolbar.module.scss';

type DentalPhotoToolbarProps = {
  className: string;
  activeTool: DentalPhotoEditTool | null;
  isMirrored: boolean;
  canEdit: boolean;
  mode?: 'photo' | 'video';
  onToolSelect: (tool: DentalPhotoEditTool | null) => void;
  onDownload: () => void;
  onDelete: () => void;
};

export const DentalPhotoToolbar: FC<DentalPhotoToolbarProps> = (props) => {
  const {
    className,
    activeTool,
    isMirrored,
    canEdit,
    mode = 'photo',
    onToolSelect,
    onDownload,
    onDelete,
  } = props;
  const { formatMessage } = useIntl();

  const showEditTools = mode === 'photo' && canEdit;

  const handleToolClick = (tool: DentalPhotoEditTool) => {
    if (activeTool === tool) {
      onToolSelect(null);
    } else {
      onToolSelect(tool);
    }
  };

  return (
    <div
      className={cn(styles.container, className)}
      data-section="photo-edit-toolbar"
    >
      {showEditTools &&
        EDIT_TOOLS.map((tool) => (
          <Tooltip.Primary
            key={tool}
            side="right"
            content={
              <span className="p3">
                {formatMessage(dentalPhotoToolbarMessages[tool])}
              </span>
            }
          >
            <button
              type="button"
              className={cn(
                styles.button,
                (activeTool === tool || (tool === 'mirror' && isMirrored)) &&
                  styles.active,
              )}
              onClick={() => handleToolClick(tool)}
            >
              <Icon name={TOOL_TO_ICON[tool]} size={TOOL_TO_ICON_SIZE[tool]} />
            </button>
          </Tooltip.Primary>
        ))}

      <Tooltip.Primary
        side="right"
        content={
          <span className="p3">
            {formatMessage(dentalPhotoToolbarMessages.download)}
          </span>
        }
      >
        <button type="button" className={styles.button} onClick={onDownload}>
          <Icon name="download" size={32} />
        </button>
      </Tooltip.Primary>

      {canEdit && (
        <Tooltip.Primary
          side="right"
          content={
            <span className="p3">
              {formatMessage(dentalPhotoToolbarMessages.delete)}
            </span>
          }
        >
          <button type="button" className={styles.button} onClick={onDelete}>
            <Icon name="delete" size={32} />
          </button>
        </Tooltip.Primary>
      )}
    </div>
  );
};
